import { jsx as _jsx } from "react/jsx-runtime";
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import * as PurchaseMotionTypes from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { APP } from '../../constants/tracking/App';
import { SCREENS } from '../../constants/tracking/Locations';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { productBasedOfferIdsWithMandatorySkuSelector } from '../../selectors/ProductBasedOffersSelectors';
import { hasProductVersionInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { upgradeProductSelector } from '../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../utils/urls/queryParamUtils';
import PurchaseMotionButtonWrapper from '../common/purchaseMotions/PurchaseMotionButtonWrapper';
import { useSkuAdditionalUnits } from '../merch-card/useSkuAdditionalUnits';
import GetPersonalizedPPPurchaseMotions from '../personalized-pricing-page/GetPersonalizedPPPurchaseMotions';

const FeatureTableCTA = ({
  productLevel,
  productLine,
  upgradePointApiName
}) => {
  const activeCurrencyCode = useSelector(activeCurrencySelector);
  const {
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const ownsProduct = useSelector(state => hasProductVersionInProductInventorySelector(state, {
    skuId
  }));
  const productBasedOffers = useSelector(state => productBasedOfferIdsWithMandatorySkuSelector(state, {
    skuIds: [skuId]
  }));
  const productConfigurations = [createProductConfig({
    skuId
  })]; // Temporary solution. See function details.

  const purchaseMotions = GetPersonalizedPPPurchaseMotions(upgradePointApiName);
  const contactIsc = purchaseMotions.includes(PurchaseMotionTypes.TALK_TO_SALES_FALLBACK);
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SCREENS.COMPARE_PROFESSIONAL,
    // TODO UPDATE
    uniqueId: `${SCREENS.COMPARE_PROFESSIONAL}-${upgradeProduct}`,
    upgradeProduct
  };
  const {
    queryParamTerm
  } = useQueryParamTerm(); // todo hardcode to "annual"

  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
      use: "primary",
      level: 1,
      currencyCode: activeCurrencyCode,
      ownsProduct: ownsProduct,
      purchaseMotions: purchaseMotions,
      productBasedOffers: productBasedOffers,
      productConfigurations: productConfigurations,
      upgradeData: upgradeData,
      isAssignable: !contactIsc,
      trackingSource: SCREENS.COMPARE_PROFESSIONAL // todo update?
      ,
      queryParamTerm: queryParamTerm,
      skipMCConfirmationPage: true
    })
  });
};

export default FeatureTableCTA;